import moment from 'moment';
import React from 'react';
import { OrderHistoryItem } from '../../../../../core-module/services/logistics/types';

interface Props {
  readonly item: OrderHistoryItem;
}

const OrderHistoryItemComponent: React.FC<Props> = ({ item }) => {
  return (
    <div style={{ color: 'black' }}>
      <h4 style={{ margin: 0, fontWeight: 600 }}>Bezorgmoment</h4>
      <span>
        {moment(item.date).format('dddd DD MMMM')}, {item.time}
      </span>

      <h4 style={{ margin: 0, marginTop: '10px', fontWeight: 600 }}>Bezorgadres</h4>
      <div>
        {item.street_name} {item.door_number}
      </div>
      <div>
        {item.postal_code} {item.city}
      </div>

      <h4 style={{ margin: 0, marginTop: '10px', fontWeight: 600 }}>Inhoud</h4>
      <ul style={{ paddingLeft: '20px' }}>
        {item.dishes.map((dish, index: number) => (
          <li key={index}>
            {dish.amount}x {dish.name}, {dish.portion_description}
          </li>
        ))}
      </ul>
    </div>
  );
};

export { OrderHistoryItemComponent };
